import React from "react";
import { Button } from "react-bootstrap";

const ReusableButton = ({ label, onClick, className = "", style = {} }) => (
  <Button
    variant="primary"
    className={`btn-3d ${className}`.trim()}
    style={{ border: "none", ...style }}
    onClick={onClick}
  >
    {label}
  </Button>
);

export default ReusableButton;
